export default "__VITE_ASSET__BqE8Gg1Z__"